var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('model',{attrs:{"width":"auto","title":"联系作者"}},[_c('lh-img',{attrs:{"width":"300px","src":require('../../static/wx.jpg')}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }